import React from "react";

import Alert, { AlertProps } from "@mui/material/Alert";
import Button from "@mui/material/Button";
import styled from "@mui/material/styles/styled";
import Typography from "@mui/material/Typography";

export const Text = styled(Typography)(({ theme }) => ({
  ...theme.typography.bodySecondaryReg,
  color: theme.palette.text.med,
}));

type WrapperProps = AlertProps & {
  iconAlign: "top" | "center";
  iconPosition: "left" | "top";
  fullWidth: boolean;
};

export const Wrapper = styled<React.FC<WrapperProps>>(
  ({ iconAlign: _ia, iconPosition: _ip, fullWidth: _fw, ...props }) => (
    <Alert {...props} />
  ),
)(({ fullWidth, iconAlign, iconPosition }) => ({
  border: "none",
  padding: "8px",
  paddingLeft: iconPosition === "top" ? "8px" : "16px",
  width: fullWidth ? "100%" : "fit-content",
  maxWidth: "100%",
  flexShrink: 0,

  flexDirection: iconPosition === "top" ? "column" : "row",

  "& .MuiAlert-action": {
    flexShrink: 0,
    marginRight: "0px",
    alignSelf: "center",
    paddingRight: "4px",
    paddingLeft: "12px",
  },
  "&.column, &.text-column": {
    alignItems: iconPosition === "top" ? "center" : "flex-start",
    "& .MuiAlert-message": {
      paddingTop: "3px", // slight offset so the text aligns horizontally with the icon
      paddingBottom: "4px",
    },
  },
  "&.column .MuiAlert-action": {
    alignSelf: "initial",
  },
  ...(iconAlign === "center" && {
    "& .MuiAlert-icon": {
      alignSelf: "center",
    },
  }),
}));

export const InfoPanelAction = styled(Button)(({ theme, variant }) => ({
  fontWeight: 600,
  ...(variant === "contained" && {
    padding: theme.spacing(1, 1.5),
  }),
}));
